import React from "react";
import AddModuleWrapper from "./Module/Add/AddModuleWrapper";
import ChapterListLayoutWrapper from "./Chapter/ChapterListLayoutWrapper";
import ChapterViewFormWrapper from "./Chapter/View/ChapterViewFormWrapper";

type Props = {
  allModules: any;
  moduleIsLoading: boolean;
  chaptersIsLoading : boolean ;
  allchapters:any
};

const ModulesAndChapterLayout = ({ allModules, moduleIsLoading , chaptersIsLoading , allchapters  }: Props) => {
  
  return (
    <div className="w-full h-full  p-3 overflow-auto grid grid-cols-12 gap-4">
     <div className="h-full col-span-2"> 
    {/* Module List  Tab*/}
         <AddModuleWrapper
        moduleItems={allModules}
        moduleIsLoading={moduleIsLoading}
      />
     </div>
      {/* Chapter List  Tab*/}
     <div className="h-full col-span-2">
         <ChapterListLayoutWrapper
           chaptersIsLoading={chaptersIsLoading} 
           allchapters={allchapters}
      />
     </div>
     <div className="h-full col-span-8">
        {/* Chapter Details Tab */}
       <ChapterViewFormWrapper/>

     </div>
    </div>
  );
};

export default ModulesAndChapterLayout;
